import { Controller, useFormContext } from "react-hook-form";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Select from "../../../../Form/Select";
import { useTranslationApp } from "../../../../../lib/i18next";
import {
  OVERLAY_POSITION_PLACEHOLDER,
  OVERLAY_SHAPE_PLACEHOLDER,
  OVERLAY_OPACITY_PLACEHOLDER,
  PRICE_LABEL_PLACEHOLDER,
  FIELD_REQUIRED,
  SOLID,
  TRANSPARENT,
  LABEL_TEXT_PLACEHOLDER,
  AUTOMATIC_LABELS,
  STRIKETHROUGH_PRICE_PLACEHOLDER,
  PERCENTAGE_OFF_PLACEHOLDER,
  FREE_SHIPPING_PLACEHOLDER,
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  RECTANGLE,
  CIRCLE,
  TRIANGLE,
  PILL,
  OVERLAY_TEXT_FONT_PLACEHOLDER,
  ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT,
} from "../../../../../i18n/keysTranslations";
import Switch from "../../../../Form/Switch";

const CatalogLabelsForm = () => {
  const { control, watch } = useFormContext();
  const { t } = useTranslationApp();

  const type = watch("type");

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Select
          label={t(LABEL_TEXT_PLACEHOLDER)}
          name="type"
          fullWidth
          variant="filled"
          control={control}
          doTranslate={true}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
          options={[
            { value: "automatic", label: AUTOMATIC_LABELS },
            { value: "price", label: PRICE_LABEL_PLACEHOLDER },
            {
              value: "strikethroughPrice",
              label: STRIKETHROUGH_PRICE_PLACEHOLDER,
            },
            { value: "percentageOff", label: PERCENTAGE_OFF_PLACEHOLDER },
            { value: "freeShipping", label: FREE_SHIPPING_PLACEHOLDER },
          ]}
        />
        {type !== "automatic" && (
          <Controller
            name="autoShowEnrollStatus"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Switch
                isActive={value}
                onChangeIsActive={(value) => onChange(value)}
                labelActive={ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT}
                labelDeactivate={ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT}
              />
            )}
          />
        )}
      </Grid>

      <Grid item xs={12}>
        <Select
          label={t(OVERLAY_POSITION_PLACEHOLDER)}
          name="overlayPosition"
          fullWidth
          variant="filled"
          control={control}
          doTranslate={true}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
          options={[
            { value: "topLeft", label: TOP_LEFT },
            { value: "topRight", label: TOP_RIGHT },
            { value: "bottomLeft", label: BOTTOM_LEFT },
            { value: "bottomRight", label: BOTTOM_RIGHT },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <Select
          label={t(OVERLAY_SHAPE_PLACEHOLDER)}
          name="overlayShape"
          fullWidth
          variant="filled"
          control={control}
          doTranslate={true}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
          options={[
            { value: "rectangle", label: RECTANGLE },
            { value: "pill", label: PILL },
            { value: "circle", label: CIRCLE },
            { value: "triangle", label: TRIANGLE },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl component="fieldset" fullWidth variant="filled">
          <FormLabel component="legend">
            {t(OVERLAY_OPACITY_PLACEHOLDER)}
          </FormLabel>
          <Controller
            control={control}
            name="opacity"
            render={({ field }) => (
              <RadioGroup {...field}>
                <FormControlLabel
                  value={100}
                  control={<Radio />}
                  label={t(SOLID)}
                />
                <FormControlLabel
                  value={75}
                  control={<Radio />}
                  label={t(TRANSPARENT)}
                />
              </RadioGroup>
            )}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Select
          label={t(OVERLAY_TEXT_FONT_PLACEHOLDER)}
          name="textFont"
          fullWidth
          variant="filled"
          control={control}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
          options={[
            { value: "droidSerif", label: "Droid Serif" },
            { value: "lato", label: "Lato" },
            { value: "notoSans", label: "Noto Sans" },
            { value: "nunitoSans", label: "Nunito Sans" },
            { value: "openSans", label: "Open Sans" },
            { value: "openSansCondensed", label: "Open Sans Condensed" },
            { value: "ptSerif", label: "PT Serif" },
            { value: "robotoCondensed", label: "Roboto Condensed" },
            { value: "robotoMedium", label: "Roboto Medium" },
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default CatalogLabelsForm;
